import { Tag } from 'antd';
import type { ReactNode } from 'react';
import {
  CheckCircleOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from '../icons';
import { reservationLabel, reservationTone, type Tone } from '../lib/status';

const ICONS: Record<Tone, ReactNode> = {
  pending: <ClockCircleOutlined />,
  approved: <CheckCircleOutlined />,
  waitlisted: <ClockCircleOutlined />,
  conflict: <ExclamationCircleOutlined />,
  rejected: <CloseCircleOutlined />,
  cancelled: <CloseOutlined />,
  expired: <ClockCircleOutlined />,
  done: <CheckOutlined />,
};

export function StatusBadge(props: { status: string; reasonType?: string | null; label?: string }) {
  const tone = reservationTone(props.status, props.reasonType);
  const label = props.label ?? reservationLabel(props.status, props.reasonType);
  return (
    <Tag icon={ICONS[tone]} className={`status-${tone}`}>
      {label}
    </Tag>
  );
}
